import { Component } from 'react';
import { Sentry } from '@/sentry';
import { logOutActions } from '@/helpers';

// Red de seguridad global: si algo truena durante el render (p.ej. datos de
// sesión corruptos en localStorage/location.state), sin esto React desmonta
// todo el árbol y deja <div id="root"> vacío, sin ningún indicio visual ni
// forma de recuperarse para el usuario más que borrar los datos del sitio a mano.
class ErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError () {
    return { hasError: true };
  }

  componentDidCatch (error, info) {
    console.error('Error no controlado en la aplicación:', error, info);
    Sentry.captureException(error, { extra: { componentStack: info?.componentStack } });
  }

  handleRetry = () => {
    // Reutiliza el logout existente: limpia tokenExp/userInfo/isAuth/etc. y
    // recarga hacia /login, para que datos de sesión corruptos no dejen al
    // usuario atrapado sin poder entrar salvo cambiando de equipo/explorador.
    logOutActions();
  };

  render () {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#0a2761',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '2rem',
            zIndex: 2000
          }}
        >
          <h2>Ocurrió un error inesperado</h2>
          <p style={{ maxWidth: '420px', marginTop: '0.5rem' }}>
            Vamos a cerrar tu sesión local para intentar solucionarlo. Vuelve a iniciar sesión.
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              marginTop: '1.5rem',
              padding: '0.6rem 1.5rem',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              background: '#365DEE',
              color: '#fff',
              fontSize: '1rem'
            }}
          >
            Volver a intentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
